export type MessageFromOrderingAppWindowKey = 'GRILLD_ORDERING_APP_EVENT' | 'GRILLD_GA_EVENT'

export type MessageFromOrderingAppWindowOp =
  | 'signed_in_state'
  | 'cart_item_count'
  | 'user_tags'
  | 'did_sign_up_from_website'
  | 'did_sign_in_from_website'
  | 'did_sign_out_from_website'
  | 'order_at_table_error_dismissed'

interface BaseMessagePayload<K = MessageFromOrderingAppWindowKey, T = string, V = any> {
  key: K
  op: T
  value: V
}

type MessagePayloadSignedInState = BaseMessagePayload<'GRILLD_ORDERING_APP_EVENT', 'signed_in_state', boolean>
type MessagePayloadCartItemCount = BaseMessagePayload<'GRILLD_ORDERING_APP_EVENT', 'cart_item_count', number>
type MessagePayloadUserTags = BaseMessagePayload<
  'GRILLD_ORDERING_APP_EVENT',
  'user_tags',
  Record<string, Record<string, string>>
>
type MessagePayloadDidSignUpFromWebsite = BaseMessagePayload<
  'GRILLD_ORDERING_APP_EVENT',
  'did_sign_up_from_website',
  boolean
>
type MessagePayloadDidSignInFromWebsite = BaseMessagePayload<
  'GRILLD_ORDERING_APP_EVENT',
  'did_sign_in_from_website',
  boolean
>
type MessagePayloadDidSignOutFromWebsite = BaseMessagePayload<
  'GRILLD_ORDERING_APP_EVENT',
  'did_sign_out_from_website',
  boolean
>
type MessagePayloadOrderAtTableErrorDismissed = BaseMessagePayload<
  'GRILLD_ORDERING_APP_EVENT',
  'order_at_table_error_dismissed',
  undefined
>

export type MessagePayloadGaEvent = BaseMessagePayload<'GRILLD_GA_EVENT', string, Record<string, any>>

export type MessagePayload =
  | MessagePayloadSignedInState
  | MessagePayloadCartItemCount
  | MessagePayloadUserTags
  | MessagePayloadDidSignUpFromWebsite
  | MessagePayloadDidSignInFromWebsite
  | MessagePayloadDidSignOutFromWebsite
  | MessagePayloadOrderAtTableErrorDismissed

export function isLegacyOrderingMessage(value: unknown): value is MessagePayload | MessagePayloadGaEvent {
  if (!value || typeof value !== 'object') return false

  const message = value as Record<string, unknown>
  if (message.key === 'GRILLD_GA_EVENT') {
    return typeof message.op === 'string' && !!message.value && typeof message.value === 'object'
  }

  return message.key === 'GRILLD_ORDERING_APP_EVENT' && typeof message.op === 'string' && 'value' in message
}
